import {
  decodeErrorEnvelope,
  OPERATOR_CONTEXT_REQUIRED,
} from '@backrs_ui/grow-ui/src/redux/institutionAdmin/institutionAdmin.contract';

/**
 * The context refusal is the exception: where roots were offered the picker renders instead of
 * a section, and where none could be read there is nothing to choose — so the prose would
 * instruct an action that cannot be taken either way
 */
export const refusalProse = (error: unknown): string | null => {
  const envelope = decodeErrorEnvelope(error);

  if (envelope === null || envelope.code === OPERATOR_CONTEXT_REQUIRED) return null;

  return envelope.prose;
};
